<template>
	<div class="page-in">
		<van-nav-bar :title="$t('我的分红计划')" fixed placeholder left-arrow z-index="99" @click-left="back" :border="false"
			v-if="isMobileFlag" />
		<div class="inside-page">
			<!-- 手机 -->
			<div class="m-container" v-if="isMobileFlag">
				<div class="m-tabs">
					<div v-for="(item, index) in tabList" :key="index" :class="{ tabitem: true, on: index == curTab }"
						@click="changeTab(index)">{{ $t(item.name) }}
					</div>
				</div>
				<template v-if="tableData && tableData.length > 0">
				<div class="plan-cells" >
					<div class="plan-panel" v-for="(item,index) in tableData" :key="index">
						<div class="plan-panel_hd">
							<span>{{$t('分红计划编号')}}</span><span>{{item.id}}</span>
						</div>
						<div class="plan-panel_bd">
							<el-row :gutter="10">
								<el-col :span="12">
									<span class="label">{{$t('分红编号')}}</span>{{item.sn}}
								</el-col>
								<el-col :span="12">
									<span class="label">{{$t('已分红期数')}}</span>{{item.periods}}
								</el-col>
								<el-col :span="12">
									<span class="label">{{$t('剩余分红期数')}}</span>{{item.treat_periods}}
								</el-col>
								<el-col :span="12">
									<span class="label">{{$t('已分红积分')}}</span>{{item.current_price}}
								</el-col>
								<el-col :span="12">
									<span class="label">{{$t('总分红积分')}}</span>{{item.total_price}}
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
				</template>
				<empty v-else></empty>
			</div>
			<!-- pc -->
			<div class="layui-container" v-else>
				<div class="ucenter">
					<div class="uc-breadcrumb">
						<el-link type="info" @click="back">
							<span class="iconfont icon-l-left"></span><span>{{$t('返回')}}</span>
						</el-link>
					</div>
					<UserPanel></UserPanel>
					<div class="ucenter-ht"></div>
					<div class="ucenter-content">
						<div class="ucenter-cell">
							<div class="ucenter-content-hd"><span class="tt">{{$t('分红计划概览')}}</span></div>
							<div class="ucenter-filter flex-center" >
								<div class="filter-label">
									{{$t('分红状态')}}
								</div>
								<div class="flex-col">
									<el-select v-model="form.status" :placeholder="$t('请选择')"
										@change="changeStatus">
										<el-option :label="$t('进行中')" value="1"></el-option>
										<el-option :label="$t('已完成')" value="0"></el-option>
									</el-select>
								</div>
							</div>
							<template v-if="tableData && tableData.length > 0">
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="sn" :label="$t('分红编号')" align="center">
								</el-table-column>
								<el-table-column prop="periods" :label="$t('已分红期数')" align="center">
								</el-table-column>
								<el-table-column prop="treat_periods" :label="$t('剩余分红期数')" align="center">
								</el-table-column>
								<el-table-column prop="current_price" :label="$t('已分红积分')" align="center">
									<template slot-scope="scope">
										{{formatNumber(scope.row.current_price)}}
									</template>
								</el-table-column>
								<el-table-column prop="total_price" :label="$t('总分红积分')" align="center">
									<template slot-scope="scope">
										{{formatNumber(scope.row.total_price)}}
									</template>
								</el-table-column>
								<el-table-column prop="status" :label="$t('分红状态')" align="center">
									<template slot-scope="scope">
										<span
											:class="scope.row.status === 1 ? 'text-primary' : 'text-danger'">{{scope.row.status === 1 ? $t('进行中') : $t('已完成')}}</span>
									</template>
								</el-table-column>
							</el-table>
							<div class="ui-page">
								<el-pagination background :small="isMobileFlag" :pager-count="5"
									layout="prev, pager, next" :current-page.sync="currentPage"
									@current-change="handleSizeChange" :page-size="listLimit"
									:total="listTotal"></el-pagination>
							</div>
							
							</template>
							<empty v-else></empty>
						</div>
						<div class="bonus-tip">
							<div class="title">{{$t('分红计划规则说明')}}</div>
							<div class="content">
								{{$t('分红计划规则内容')}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {user_bonus_index_api} from "@/api/user"
	import UserPanel from './components/UserPanel'
	import empty from '@/components/empty.vue'
	export default {
		components: {
			UserPanel,
			empty
		},
		data() {
			return {
				tabList: [{
					name: "进行中",
					status: 1
				}, {
					name: "已完成",
					status: 0
				}],
				curTab: 0,
				form: {
					status: '',
				},
				tableData: null,
				currentPage: 1,
				listPage: 1,
				listLimit: 5,
				listTotal: 0,
			};
		},
		methods: {
			changeTab(index) {
				this.curTab = index;
				this.getBonus(this.tabList[index].status)
			},
			changeStatus() {
				this.getBonus(this.form.status)
			},
			async getBonus(id) {
				let data = {
					page: this.listPage,
					limit: this.listPage == 1 ? 10 : this.listLimit,
					status: id
				};
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await user_bonus_index_api(data).then(res => {
					console.log(res,'sssssss')
					if (res && res.data.code == 1) {
						this.tableData = res.data.data.list
						this.listTotal = res.data.data.total
						loading.close()
					}
				});
			},
			handleSizeChange(e) {
				this.listPage = e;
				this.getBonus();
			}
		},
		mounted() {
			this.getBonus()
			
		}
	}
</script>
<style scoped>
	.uc-breadcrumb {
		margin-bottom: 15px;
	}

	.ucenter-ht {
		height: 20px;
	}

	.ucenter-filter .el-select {
		width: 100%;
	}

	.ucenter-filter .el-button {
		width: 110px;
	}
	@media (min-width:1200px) {
		.ucenter-filter{
			max-width: 40%;
		}
	}
	.plan-panel {
		background-color: #f2f2f2;
		margin-bottom: 10px;
	}

	.plan-panel_hd {
		display: flex;
		align-items: center;
		background-color: #eddec9;
		height: 36px;
		padding: 0 15px;
	}

	.plan-panel_bd {
		padding: 10px 15px;
	}

	.plan-panel_bd .label {
		margin-right: 10px;
		color: #666;
	}

	.plan-panel_bd .el-col {
		padding: 5px 0;
	}

	.m-tabs {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.m-tabs .tabitem {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		height: 40px;
		background: #FFFFFF;
		border-radius: 20px;
		border: 1px solid #8D8D8D;
		cursor: pointer;
		font-size: 14px;
		min-width: 110px;
		padding: 0 10px;
		margin-right: 10px;
	}

	.m-tabs .tabitem.on {
		background: #EEDDC9;
		border: 1px solid #EEDDC9;
	}
</style>